import { useCallback, useEffect, useState } from "react";
import { api, ApiError } from "./apiClient";
import type { AuthedUser } from "../types/authedUser";

export function useCurrentAppUser() {
  const [user, setUser] = useState<AuthedUser | null>(null);
  const [loading, setLoading] = useState(true);
  // A logged-in-to-Identity user can still fail /api/me with a 403 — pending
  // approval or revoked access (see auth.ts's requireUser). App.tsx uses
  // this to show a clear blocked-access screen instead of the full app
  // shell 403-ing on every subsequent call.
  const [error, setError] = useState<ApiError | null>(null);

  const refresh = useCallback(() => {
    return api
      .get<{ user: AuthedUser }>("/api/me")
      .then((data) => {
        setUser(data.user);
        setError(null);
      })
      .catch((err) => {
        setUser(null);
        setError(err instanceof ApiError ? err : new ApiError(0, "Failed to load your account."));
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { user, role: user?.role ?? null, loading, error, refresh };
}
